export default (route) => `/${route}`;
    //process.env.NODE_ENV === 'development'? `/${route}` : `/react-webpack-lazy-loading/${route}`;


// WEBPACK FOOTER //
// ./src/commons/utils/basePath.js